import React from "react";

const Footer = ({ isBottom }) => {
    if (isBottom === true) {
        return(
        <div class="bg-color-0 w-full p-6 mt-16 absolute bottom-0 footer-mobile">
            <h1 class="text-white font-sec text-xl text-center">Kõik õigused kaitstud © 2024 <br/> <a class="underline" href="https://icons8.com">Icons</a> | <a class="underline" href="https://placeit.net/">Mockup</a></h1>
        </div>
        )
    } else {
        return(
        <div class="bg-color-0 w-full p-6 mt-16">
            <h1 class="text-white font-sec text-xl text-center">Kõik õigused kaitstud © 2024 <br/> <a class="underline" href="https://icons8.com">Icons</a> | <a class="underline" href="https://placeit.net/">Mockup</a></h1>
        </div>
        )
    }

}

export default Footer;